import { ComponentFactoryResolver, Directive, ViewContainerRef } from '@angular/core';
import { NgControl } from '@angular/forms';
import { CmydFormErrorComponent } from './cmyd-form-error.component';

@Directive({
  selector: '[cmydFormError]'
})
export class CmydFormErrorDirective {

  constructor(
    private control: NgControl,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CmydFormErrorComponent);
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<CmydFormErrorComponent>(componentFactory);
    componentRef.instance.controlName = control!;
  }

}
